import { Link } from "react-router-dom";
import logoSrc from "@/assets/cloud-logo.webp";
import whiteLogoSrc from "@/assets/cloud-logo-white.webp";

interface LogoProps {
  className?: string;
  variant?: "full" | "mark";
  tone?: "default" | "white";
}

export const Logo = ({ className = "", variant = "full", tone = "default" }: LogoProps) => {
  const src = tone === "white" ? whiteLogoSrc : logoSrc;

  if (variant === "mark") {
    return (
      <span className={className}>
        <img
          src={src}
          alt="Cloud Redovisning"
          className="h-9 w-auto"
          width={180}
          height={36}
          decoding="async"
        />
      </span>
    );
  }

  return (
    <Link
      to="/"
      className={`group inline-flex items-center ${className}`}
      aria-label="Cloud Redovisning – hem"
    >
      <img
        src={src}
        alt="Cloud Redovisning & Administration"
        width={240}
        height={52}
        decoding="async"
        className="h-11 md:h-12 w-auto transition-transform duration-500 group-hover:scale-[1.02]"
      />
    </Link>
  );
};
